module.exports = __webpack_public_path__ + "media/logos/ri_marketplace-739554fa.png";